module.exports = __webpack_public_path__ + "img/58.209a901b.jpg";